export const defaultConfig = [
	{
		name: 'age'
	},
	{
		name: 'goal'
	},
	{
		name: 'height'
	},
	{
		name: 'weight'
	},
	// {
	//   name: 'target_weight',
	// },
	// {
	//   name: 'fat',
	// },
	// {
	// 	name: 'muscle_focus'
	// },
	{
	  name: 'zones',
	},
	{
		name: 'pushUps'
	},
	{
		name: 'activities_preferences'
	},
	{
		name: 'devices'
	},
	{
		name: 'choose_days'
	},
	{
		name: 'health_issues'
	},
	{
		name: 'diet_type'
	},
	{
		name: 'successfully_lost_weight'
	},
	{
		name: 'previous_fails'
	},
	{
		name: 'mail'
	}
];

export const test = [
	{
		name: 'age'
	},
	{
		name: 'goal'
	},
	{
		name: 'mail'
	}
];

export const stepsDetails = {
	goal: {
		showActionBar: true
	},
	zones: {
		showActionBar: true
	},
	motivation: {
		showActionBar: true
	},
	nutrition_approaches: {
		showActionBar: true
	},
	medications: {
		showActionBar: true
	},
	diseases: {
		showActionBar: true
	},
	weight: {
		showActionBar: true
	},
	target_weight: {
		showActionBar: true
	},
	height: {
		showActionBar: true
	},
	mail: {
		showActionBar: true
	},
	body_mass: {
		showActionBar: true
	},
	caffeine: {
		showActionBar: true
	},
	quit_exercising: {
		showActionBar: true
	},
	map: {
		showActionBar: true
	},
	fat: {
		showActionBar: true
	},
	before_after: {
		showActionBar: true
	},
	nutrition_experts: {
		showActionBar: true
	},
	health_issues: {
		showActionBar: true
	},
	devices: {
		showActionBar: true
	},
	previous_fails: {
		showActionBar: true
	},
	diet_type: {
		showActionBar: true
	},
	motivates_exercise: {
		showActionBar: true
	},
	focus: {
		showActionBar: true
	},
	habbits: {
		showActionBar: true
	},
	trainers: {
		showActionBar: true
	},
	result_page_step: {
		showActionBar: true
	},
	medicine_experts: {
		showActionBar: true
	},
	activities_preferences: {
		showActionBar: true
	},
	choose_days: {
		showActionBar: true
	}
};
